<div class="d-flex filters-head-div d-md-none d-lg-none">
  <div class="filters-heading me-2">Filters</div>
  <mat-chip class="reset-chip" (click)="resetFilters()">
    <img src="/assets/images/job-filters-reset.svg" alt="job-filters-reset" class="me-1" />Reset
  </mat-chip>
</div>

<div class="products-filter-container">
  <section class="product-filters-section p-3" [ngClass]="{ 'product-filters-section-spinner' : !isSpecificationLoading}">
    <div>
      <div>
        <div class="d-none d-md-block d-lg-block">
          <div class="filters-head-div">
            <div class="filters-heading me-2">Filters</div>
            <mat-chip class="reset-chip" (click)="resetFilters()">
              <img src="/assets/images/job-filters-reset.svg" alt="job-filters-reset" class="me-1" />Reset
            </mat-chip>
          </div>
        </div>
        <div class="card mt-3" style="height: 95%">
          <div class="card-body">
            <form [formGroup]="filterForm">
              <div class="filter-field-container" *ngIf="filterColumns?.includes('Products')">
                <div class="filter-label mb-3">
                  {{ heading }}
                </div>
                <mat-chip-list>
                  <div *ngFor="let controlName of filterControls">
                
                    <!-- Skip showing individual 'From' or 'To' if both values are present -->
                    <ng-container *ngIf="!(controlName.includes('From') && filterControls.includes(controlName.replace('From', 'To')) &&
                                            filterForm.get(controlName)?.value && filterForm.get(controlName.replace('From', 'To'))?.value) &&
                                         !(controlName.includes('To') && filterControls.includes(controlName.replace('To', 'From')) &&
                                            filterForm.get(controlName)?.value && filterForm.get(controlName.replace('To', 'From'))?.value); else combinedRangeChip">
                
                      <!-- Handle array values -->
                      <ng-container *ngIf="isArray(filterForm.get(controlName)?.value); else singleChip">
                        <mat-chip *ngFor="let item of filterForm.get(controlName)?.value"
                                  class="reset-chip"
                                  [class.d-none]="item === true || item === 'true'"
                                  [selectable]="selectable"
                                  [removable]="removable"
                                  (removed)="removeTextValues(controlName, item, filterForm.get(controlName))">
                          {{ item | truncateText: 8 }}
                          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                      </ng-container>
                
                      <!-- Handle single value -->
                      <ng-template #singleChip>
                        <mat-chip *ngIf="filterForm.get(controlName)?.value"
                                  class="reset-chip"
                                  [selectable]="selectable"
                                  [removable]="removable"
                                  (removed)="remove(controlName, filterForm.get(controlName)?.value)">
                          {{ filterForm.get(controlName)?.value }}
                          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                      </ng-template>
                    </ng-container>
                
                    <!-- Combined chip when both From and To have values -->
                    <ng-template #combinedRangeChip>
                      <mat-chip *ngIf="controlName.includes('From')" class="reset-chip"
                                [selectable]="selectable"
                                [removable]="removable"
                                (removed)="removeRange(controlName.replace('From', ''))">
                        {{ controlName.replace('From', '') }}: 
                        {{ filterForm.get(controlName)?.value }} - {{ filterForm.get(controlName.replace('From', 'To'))?.value }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                    </ng-template>
                
                  </div>
                </mat-chip-list>
                
                
  
              </div>
  
              <div class="filter-field-container" *ngIf="filterColumns?.includes('Region')">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Region</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input #autoCompleteCountryInput matInput [value]="filterForm.get('country')?.value"
                      [matAutocomplete]="countryAuto" placeholder="Search for country"
                      (input)="onInputChange($event, 'country')"
                      (keydown.enter)="$event.preventDefault()" />
                    <mat-autocomplete #countryAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'country')">
                      <mat-option *ngFor="let country of filteredCountries" [value]="country.countryName">
                        {{ country.countryName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input #autoCompleteStateInput matInput [matAutocomplete]="stateAuto"
                      placeholder="Search for state" />
                    <mat-autocomplete #autoCompleteInput #stateAuto="matAutocomplete"
                      (keydown.enter)="$event.preventDefault()" (input)="onInputChange($event, 'state')"
                      (optionSelected)="onOptionSelected($event, 'state')">
                      <mat-option *ngFor="let state of filteredStates" [value]="state.stateName">
                        {{ state.stateName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input #autoCompleteInput matInput [matAutocomplete]="cityAuto" placeholder="Search for city" (input)="onInputChange($event, 'city')" (keydown.enter)="$event.preventDefault()" />
                    <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'city')">
                      <mat-option *ngFor="let city of filteredCities" [value]="city.cityName">
                        {{ city.cityName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-expansion-panel>
  
              </div>
  
              <div class="filter-field-container">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">
                      Brands
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput [matAutocomplete]="brandsAuto" placeholder="Search for Brands"
                      (input)="onInputChange($event, 'brand')" />
                    <mat-autocomplete #brandsAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'brand')">
                      <mat-option *ngFor="let brand of filteredBrands" [value]="brand">
                        {{ brand | titlecase}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-expansion-panel>
              </div>
  
              <div class="filter-field-container">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">
                      Categories
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput [matAutocomplete]="categoriesAuto" placeholder="Search for Categories" />
                    <mat-autocomplete #categoriesAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'category')">
                      <mat-option *ngFor="let category of filteredCategories" [value]="category">
                        {{ category | titlecase }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-expansion-panel>
              </div>
  
              <ng-container *ngIf="!isSpecificationLoading; else elseSpecificationBlock">
                <div class="spinner-container">
                  <div class="loading-spin"></div>
                </div>
              </ng-container>
              <ng-template #elseSpecificationBlock>
                <div *ngFor="let spec of filterSpecifications; let i = index">
                  <mat-expansion-panel class="spec-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="filter-label">{{ spec?.specificationName | titlecase }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="spec?.specificationType === 'Text'; else numberTemplate">
                      <mat-form-field appearance="outline" class="input-font w-100 selectFormField">
                        <mat-select multiple placeholder="Filter By {{ spec?.specificationName }}"
                           #filterMatSelect (selectionChange)="onSelectionChange($event, spec?.specificationName)">
                          <mat-option *ngFor="let value of (spec?.textValues || []);" [value]="value | titlecase">
                            {{ value | titlecase }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #numberTemplate>
                      <mat-slider min="{{ spec?.numberValues?.min }}" max="{{ spec?.numberValues?.max }}" class="w-100">
                        <input matSliderStartThumb [value]="this.filterForm.get(spec?.specificationName + 'From')?.value" (input)="rangeValueChange($event, spec?.specificationName + 'From', spec?.specificationName)" />
                        <input matSliderEndThumb [value]="this.filterForm.get(spec?.specificationName + 'To')?.value" (input)="rangeValueChange($event, spec?.specificationName + 'To', spec?.specificationName)"/>
                      </mat-slider>
                      <p style="margin-bottom: 8px;">
                        {{ filterForm.get(spec?.specificationName + 'From')?.value || spec?.numberValues?.min }} {{
                        spec?.fromUnit }} to
                        {{ filterForm.get(spec?.specificationName + 'To')?.value || spec?.numberValues?.max }} {{
                        spec?.fromUnit }}
                      </p>
                      <div class="button-container">
                        <button
                          class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
                          [disabled]="!isRangeSubmit"
                          (click)="applyFilter()">Submit</button>
                      </div>
                    </ng-template>
                  </mat-expansion-panel>
                </div>
              </ng-template>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>